import { globalState } from './state.js';
import { elements } from './domElements.js';

import { initializeWebSocket, sendWebSocketMessage, closeWebSocket } from './websocketService.js';
import { initGlobalErrorHandling, appendLog } from './loggerService.js';
import { initInputService } from './services/inputService.js';
import { stopVideoPlayback } from './services/videoPlaybackService.js';
import { closeAudio } from './services/audioPlaybackService.js';

import { initSidebarControls } from './ui/sidebarControls.js';
import { initTaskbarControls } from './ui/taskbarControls.js';
import { initModals } from './ui/modals.js';
import { initAppDrawer } from './ui/appDrawer.js';
import { initHeaderControls } from './ui/headerControls.js';

document.addEventListener('DOMContentLoaded', () => {
    initGlobalErrorHandling();

    initHeaderControls();
    initSidebarControls();
    initTaskbarControls();
    initModals();
    initAppDrawer();

    initInputService();

    initializeWebSocket();

    appendLog('Scrcpy Desktop Client Initialized.');

    window.addEventListener('beforeunload', () => {
        if (globalState.isRunning || (globalState.ws && globalState.ws.readyState === WebSocket.OPEN)) {
            sendWebSocketMessage({ action: 'disconnect' });

            if (globalState.checkStateIntervalId) {
                clearInterval(globalState.checkStateIntervalId);
                globalState.checkStateIntervalId = null;
            }
            closeAudio();
            stopVideoPlayback();

            closeWebSocket();
            appendLog('Attempted cleanup on page unload.');
        }
    });

    if (elements.toggleLogBtn && elements.logContent) {
        elements.toggleLogBtn.addEventListener('click', () => {
            const isExpanded = elements.toggleLogBtn.getAttribute('aria-expanded') === 'true';
            elements.toggleLogBtn.setAttribute('aria-expanded', (!isExpanded).toString());
            elements.toggleLogBtn.textContent = isExpanded ? 'Show Logs' : 'Hide Logs';
            elements.logContent.classList.toggle('hidden', isExpanded);
        });
    }
    // 新增退出全屏按钮的事件处理逻辑
    const exitFullscreenBtn = document.getElementById('exitFullscreenBtn');
    if (exitFullscreenBtn) {
        exitFullscreenBtn.addEventListener('click', () => {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { // Safari
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE11
                document.msExitFullscreen();
            }
            // 点击后隐藏快速设置面板
            const quickSettingsPanel = document.getElementById('quickSettingsPanel');
            quickSettingsPanel.style.display = 'none';
        });
    }

    // 为快速设置面板中的所有按钮添加点击事件监听器
    const quickSettingsButtons = document.querySelectorAll('#quickSettingsPanel .panel-toggle-button');
    quickSettingsButtons.forEach(button => {
        button.addEventListener('click', () => {
            const quickSettingsPanel = document.getElementById('quickSettingsPanel');
            quickSettingsPanel.style.display = 'none';
        });
    });

    // 快速设置触发按钮事件处理
    const quickSettingsTrigger = document.getElementById('quickSettingsTrigger');
    const quickSettingsPanel = document.getElementById('quickSettingsPanel');
    if (quickSettingsTrigger && quickSettingsPanel) {
        quickSettingsTrigger.addEventListener('click', () => {
            if (quickSettingsPanel.style.display === 'none' || quickSettingsPanel.style.display === '') {
                quickSettingsPanel.style.display = 'block';
            } else {
                quickSettingsPanel.style.display = 'none';
            }
        });
    }
});